import { z } from "zod";
import {
  insertUserPermission,
  updateUserPermission,
} from "@/pages/admin/users/permissions/lib/mutations";

const UserPermissionSchema = z.object({
  name: z.string().min(2, { message: "Voornaam is verplicht" }),
  description: z.string().min(2, { message: "Achternaam is verplicht" }),
});

export const createUserPermission = async (formData, redirect) => {
  const validatedFields = UserPermissionSchema.safeParse({
    name: formData.name,
    description: formData.description,
  });

  if (!validatedFields.success) {
    return {
      errors: validatedFields.error.flatten().fieldErrors,
      message: "Er missen velden.",
    };
  }

  try {
    await insertUserPermission(validatedFields.data);
  } catch (err) {
    console.error(err);
    return {
      message: "Er is iets misgegaan.",
    };
  }

  redirect("/users/permissions");
};

export const editUserPermission = async (id, formData, redirect) => {
  const validatedFields = UserPermissionSchema.safeParse({
    name: formData.name,
    description: formData.description,
  });

  if (!validatedFields.success) {
    return {
      errors: validatedFields.error.flatten().fieldErrors,
      message: "Er missen velden.",
    };
  }

  const userPermissionData = {
    id,
    ...validatedFields.data,
  };

  try {
    await updateUserPermission(userPermissionData);
  } catch (err) {
    console.error(err);
    return {
      message: "Er is iets misgegaan.",
    };
  }

  redirect("/users/permissions");
};
